import Dashboard from '@views/Dashboard';
import User from '@views/User';
import UserWorkflowDocs from '@views/User/UserWorkflowDocs';
import Workflows from '@views/Workflows';
import KycChecks from '@views/Kyc/KycChecks';
import StudentProgramDetails from '@views/User/StudentProgram';
import KycDocs from '@views/Kyc/KycDocs';
import UserSourceAccount from '@views/UserSourceAccount';
import Referrals from '@views/Referrals';
import UserBeneficiaries from '@views/User/Beneficiaries';
import UserRedeemedCoins from '@views/RedeemedCoins/UserRedeemedCoins';
import FtnrForm from '@views/Ftnr';
import GoldenTickets from '@views/GoldenTicket';
import UserProfileDetails from '@views/User/UserProfile';
import OrderDetails from '@views/Order';
import OrderScreenConfig from '@views/OrderScreenConfig';
import OrderTransferChecks from '@views/OrderTransferChecks';
import Campaigns from '@views/Campaigns';
import CreateCampaign from '@views/Campaigns/CreateCampaign';
import OrdersV2Funnel from '@views/Funnel/OrdersV2Funnel';
import LuluOrdersFunnel from '@views/Funnel/LuluOrdersFunnel';
import KycFunnel from '@views/Funnel/KycFunnel';
import NronboardFunnel from '@views/Funnel/Nronboard';
import NrAccountUsers from '@views/NrAccount';
import EditNrUser from '@views/NrAccount/EditNrUser';
import Onboarding from '@views/NrAccount/Onboarding';
import NrOnboardingPage from '@views/NrOnboarding';
import Kycs from '@views/Kyc';
import SourceAccount from '@views/SourceAccount';
import ThunesFulfillments from '@views/Thunes/ThunesFulfillments';
import Jobs from '@views/jobs';
import Config from '@views/Config/Config';
import ReconDashboardConfig from '@views/Config/ReconDashboard';
import FxRatePeakingConfig from '@views/Config/FxRatePeaking';
import FeatureFlags from '@views/Config/FeatureFlags';
import TransferExperienceConfig from '@views/Config/TransferExperienceManagement';
import UaeManualPayments from '@views/uaeManualPayments';
import ManualPayoutBatch from '@views/Batch/ManualPayoutBatch';
import BatchDetailsPage from '@views/Batch/BatchDetailsPage';
import RedeemedCoins from '@views/RedeemedCoins';
import Tickets from '@views/Tickets';
import RewardsFunnel from '@views/Rewards';
import AccessManagement from '@views/AccessManagement/AccessManagement';
import BaerscrestOpsPage from '@views/Baerscrest/BaerscrestOpsPage';
import PendingOrderReceipts from '@views/OrderReceipts';
import LuluBulkSync from '@views/LuluBulkSync';
import RFITransactions from '@views/RFITransactions';
import RFIDetails from '@views/RFITransactions/RFIDetails';
import RecipientVerificationDetails from '@views/BeneficiaryVerificationDashboard/RecipientVerificationDetails';
import RecipientVerificationDashboard from '@views/BeneficiaryVerificationDashboard/RecipientVerificationDashboard';
import BBPSDashboard from '@views/BBPSDashboard';
import VdaDashboard from '@views/Funnel/SaberFunnel';
import VanceCash from '@views/VanceCash';
import ExchangeRates from '@views/ExchangeRates';
import FalconServiceDashboard from '@views/FalconServiceDashboard';
import ReconDashboard from '@views/ReconDashboard';
import RDADashboard from '@views/RDADashboard';
import VDATransferRoutingSystemDashboard from '@views/VDATransferRoutingSystemDashboard';
import LuluRefundsDashboard from '@views/LuluRefundsDashboard';
import SettlementTimelineManager from '@views/SettlementTimelineManager';
import SettlementServiceDashboard from '@views/SettlementServiceDashboard';
import UserKycTiers from '@views/UserKycTiers';
import GomsOrderFunnel from '@views/Funnel/GomsOrderFunnel';
import SardineOnHoldOrders from '@views/SardineOnHoldOrders';
import GomsOrderDashboard from '@views/GomsOrderDashboard';
import CaseInvestigationManager from '@views/CaseInvestigationManager';
import CaseInvestigationDetailsView from '@views/CaseInvestigationManager/CaseInvestigationDetailsView';
import Unauthorized from '@views/Unauthorized';
import { ROLES } from '@/constants';
import { OUTBOUND_CALLING_ROUTES } from '@views/OutboundCallingDashboard/constant';
import OutboundCallingDashboard, {
    OutboundCallingAgentsDashboard,
    OutboundCallingOpenTicketsDashboard,
    OutboundCallingClosedTicketsDashboard
} from '@views/OutboundCallingDashboard';
import LibraDashboard from '@views/LibraDashboard';
import FxServiceDashboard from '@views/FxServiceDashboard';
import FastTransferManager from '@views/FastTransferManager';


/**
 * Authenticated Routes Configuration
 *
 * Each route can have the following properties:
 * - path: string - The route path
 * - component: React.Component - The component to render
 * - lazyComponent: function - Lazy-loaded component function
 * - props: object - Props to pass to the component
 * - allowedRoles: string[] - Array of roles allowed to access this route (optional)
 *
 * If allowedRoles is not specified or is an empty array, the route is accessible to all authenticated users.
 * If allowedRoles is specified, only users with at least one of the specified roles can access the route.
 */
export const authenticatedRoutes = [
    {
        path: '/',
        component: Dashboard
    },
    {
        path: '/user/:userId',
        component: User
    },
    {
        path: '/user/:userId/documents',
        component: UserWorkflowDocs
    },
    {
        path: '/user/:userId/workflows',
        component: Workflows
    },
    {
        path: '/user/:userId/kyc/checks',
        component: KycChecks
    },
    {
        path: '/user/:userId/kyc/product/:product/provider/:provider/sub-provider/:subProvider',
        component: KycDocs
    },
    {
        path: '/user/kyc/tiers',
        component: UserKycTiers
    },
    {
        path: '/user/:userId/student-program',
        component: StudentProgramDetails
    },
    {
        path: '/user/:userId/source-accounts',
        component: UserSourceAccount
    },
    {
        path: '/user/:userId/referrals',
        component: Referrals
    },
    {
        path: '/user/:userId/beneficiaries',
        component: UserBeneficiaries
    },
    {
        path: '/user/:userId/redeemed-coins',
        component: UserRedeemedCoins
    },
    {
        path: '/user/:userId/ybl-details',
        component: FtnrForm
    },
    {
        path: '/user/:userId/golden-ticket',
        component: GoldenTickets
    },
    {
        path: '/user/:userId/user-profile',
        component: UserProfileDetails
    },
    {
        path: '/order/:orderId',
        component: OrderDetails
    },
    {
        path: '/order/:orderId/screen-config',
        component: OrderScreenConfig
    },
    {
        path: '/order/:orderId/transfer-checks',
        component: OrderTransferChecks
    },
    {
        path: '/campaign',
        component: Campaigns
    },
    {
        path: '/campaign/create',
        component: CreateCampaign,
        allowedRoles: [ROLES.REFERRAL_MANAGER]
    },
    {
        path: '/funnel/orders',
        component: OrdersV2Funnel
    },
    {
        path: '/funnel/goms-orders',
        component: GomsOrderFunnel
    },
    {
        path: '/funnel/orders/lulu',
        component: LuluOrdersFunnel
    },
    {
        path: '/sardine-on-hold',
        component: SardineOnHoldOrders
    },
    {
        path: '/funnel/kyc',
        component: KycFunnel
    },
    {
        path: '/funnel/nr-onboarding',
        component: NronboardFunnel
    },
    {
        path: '/nr-account/users',
        component: NrAccountUsers
    },
    {
        path: '/nr-account/users/:userId/edit',
        component: EditNrUser
    },
    {
        path: '/thunes/fulfillments',
        component: ThunesFulfillments
    },
    {
        path: '/nr-account/users/:userId/onboarding',
        component: Onboarding
    },
    {
        path: '/onboarding/:userId',
        component: NrOnboardingPage
    },
    {
        path: '/kyc',
        component: Kycs
    },
    {
        path: '/source-accounts',
        component: SourceAccount
    },
    {
        path: '/thunes/fulfillments',
        component: ThunesFulfillments
    },
    {
        path: '/jobs',
        component: Jobs
    },
    {
        path: '/config',
        component: Config,
        allowedRoles: [ROLES.ADMIN_ROLE, ROLES.SUPPORT_ROLE, ROLES.MANAGER_ROLE, ROLES.CONFIG_MANAGER_ROLE]
    },
    {
        path: '/config/recon',
        component: ReconDashboardConfig,
        allowedRoles: [ROLES.ADMIN_ROLE, ROLES.SUPPORT_ROLE, ROLES.MANAGER_ROLE, ROLES.CONFIG_MANAGER_ROLE, ROLES.RECON_ADMIN_ROLE]
    },
    {
        path: '/config/fx-rate-peaking',
        component: FxRatePeakingConfig,
        allowedRoles: [ROLES.ADMIN_ROLE, ROLES.SUPPORT_ROLE, ROLES.MANAGER_ROLE, ROLES.CONFIG_MANAGER_ROLE]
    },
    {
        path: '/config/feature-flags',
        component: FeatureFlags,
        allowedRoles: [ROLES.ADMIN_ROLE, ROLES.SUPPORT_ROLE, ROLES.MANAGER_ROLE, ROLES.CONFIG_MANAGER_ROLE]
    },
    {
        path: '/config/transfer-experience',
        component: TransferExperienceConfig,
        allowedRoles: [ROLES.ADMIN_ROLE, ROLES.SUPPORT_ROLE, ROLES.MANAGER_ROLE, ROLES.CONFIG_MANAGER_ROLE]
    },
    {
        path: '/manual-payments/pending',
        component: UaeManualPayments
    },
    {
        path: '/manual-payouts/batch',
        component: ManualPayoutBatch
    },
    {
        path: '/manual-payouts/batch/:batchId',
        component: BatchDetailsPage
    },
    {
        path: '/redeemed-coins',
        component: RedeemedCoins
    },
    {
        path: '/tickets',
        component: Tickets
    },
    {
        path: '/rewards',
        component: RewardsFunnel
    },
    {
        path: '/access-management',
        component: AccessManagement,
        allowedRoles: [ROLES.ADMIN_ROLE, ROLES.SUPPORT_ROLE, ROLES.ACCESS_MANAGER]
    },
    {
        path: '/baerscrest-ops',
        component: BaerscrestOpsPage
    },
    {
        path: '/non-verified-order-receipts',
        component: PendingOrderReceipts
    },
    {
        path: '/lulu-bulk-sync',
        component: LuluBulkSync
    },
    {
        path: '/rfi-transactions',
        component: RFITransactions
    },
    {
        path: '/user/:userId/order/:orderId/rfi/:rfiType',
        component: RFIDetails
    },
    {
        path: '/beneficiary-verification-dashboard/:verificationId',
        component: RecipientVerificationDetails
    },
    {
        path: '/vda-dashboard',
        component: VdaDashboard
    },
    {
        path: 'user/:userId/:walletType/:version',
        component: VanceCash
    },
    {
        path: '/platform-transfer-fees',
        component: ExchangeRates
    },
    {
        path: '/settlement-service-dashboard',
        component: SettlementServiceDashboard
    },

    {
        path: '/recon-dashboard',
        component: ReconDashboard,
        allowedRoles: [ROLES.ADMIN_ROLE, ROLES.SUPPORT_ROLE, ROLES.MANAGER_ROLE, ROLES.RECON_ADMIN_ROLE]
    },
    {
        path: '/falcon-dashboard',
        component: FalconServiceDashboard,
        allowedRoles: [
            ROLES.ADMIN_ROLE,
            ROLES.SUPPORT_ROLE,
            ROLES.FALCON_ADMIN,
            ROLES.FALCON_OPS_MANAGER,
            ROLES.FALCON_VENDOR_MANAGER,
            ROLES.FALCON_CLIENT_MANAGER,
            ROLES.FALCON_DEVELOPER
        ]
    },
    {
        path: '/rda-dashboard',
        component: RDADashboard,
        allowedRoles: [
            ROLES.ADMIN_ROLE, ROLES.SUPPORT_ROLE, ROLES.MANAGER_ROLE, ROLES.YBL_RDA_MANAGER, ROLES.RDA_DOWNTIME_MANAGER]
    },
    {
        path: '/beneficiary-verification-dashboard',
        component: RecipientVerificationDashboard
    },
    {
        path: '/vda-transfer-routing',
        component: VDATransferRoutingSystemDashboard
    },
    {
        path: '/lulu-refunds-dashboard',
        component: LuluRefundsDashboard,
        allowedRoles: [ROLES.ADMIN_ROLE, ROLES.SUPPORT_ROLE, ROLES.MANAGER_ROLE, ROLES.LULU_REFUND_MANAGER_ROLE]
    },
    {
        path: '/settlement-timeline-manager',
        component: SettlementTimelineManager
    },
    {
        path: '/bbps-dashboard',
        component: BBPSDashboard,
        allowedRoles: [
            ROLES.ADMIN_ROLE, ROLES.MANAGER_ROLE, ROLES.BBPS_MANAGER_ROLE, ROLES.SUPPORT_ROLE
        ]
    },
    {
        path: '/goms-orders',
        component: GomsOrderDashboard
    },
    {
        path: '/case-investigation-manager',
        component: CaseInvestigationManager,
        allowedRoles: [
            ROLES.ADMIN_ROLE,
            ROLES.SUPPORT_ROLE,
            ROLES.MANAGER_ROLE,
            ROLES.TRANSFER_COMPLIANCE_MGR_READ,
            ROLES.TRANSFER_COMPLIANCE_MGR_WRITE
        ]
    },
    {
        path: '/case-investigation-manager/case/:caseId',
        component: CaseInvestigationDetailsView,
        allowedRoles: [
            ROLES.ADMIN_ROLE,
            ROLES.SUPPORT_ROLE,
            ROLES.MANAGER_ROLE,
            ROLES.TRANSFER_COMPLIANCE_MGR_READ,
            ROLES.TRANSFER_COMPLIANCE_MGR_WRITE
        ]
    },
    {
        path: '/outbound-calling',
        component: OutboundCallingDashboard,
        allowedRoles: [
            ROLES.ADMIN_ROLE,
            ROLES.OUTBOUND_CALLING_ADMIN,
            ROLES.OUTBOUND_CALLING_AGENT
        ]
    },
    {
        path: OUTBOUND_CALLING_ROUTES.AGENTS_LIST,
        component: OutboundCallingAgentsDashboard,
        allowedRoles: [
            ROLES.OUTBOUND_CALLING_ADMIN
        ]
    },
    {
        path: OUTBOUND_CALLING_ROUTES.TICKETS_QUEUE,
        component: OutboundCallingOpenTicketsDashboard,
        allowedRoles: [
            ROLES.OUTBOUND_CALLING_ADMIN
        ]
    },
    {
        path: OUTBOUND_CALLING_ROUTES.CLOSED_TICKETS,
        component: OutboundCallingClosedTicketsDashboard,
        allowedRoles: [
            ROLES.OUTBOUND_CALLING_ADMIN
        ]
    },
    {
        path: '/libra-dashboard',
        component: LibraDashboard,
        allowedRoles: [
            ROLES.ADMIN_ROLE,
            ROLES.BACKOFFICE_MANAGER_ROLE
        ]
    },
    {
        path: '/fx-service-dashboard',
        component: FxServiceDashboard,
        allowedRoles: [
            ROLES.FX_SERVICE_MANAGER_ROLE,
            ROLES.FX_SERVICE_READ_ROLE
        ]
    },
    {
        path: '/fast-transfer-manager',
        component: FastTransferManager,
        allowedRoles: [
            ROLES.FAST_TRANSFERS_READ,
            ROLES.FAST_TRANSFERS_WRITE
        ]
    },
    {
        path: '/unauthorized',
        component: Unauthorized
    }
];